import React from 'react'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import {
  usePresentation,
  withPresentation
} from '../../presentation-connectors'
import { accessibilityColors } from '../../colors'

const styles = ({ COLORS }) => ({
  container: {
    height: '0',
    paddingBottom: '56.25%',
    position: 'relative'
  },
  holder: {
    color: COLORS.TEXT.OFF_BLACK.NORMAL,
    backgroundColor: '#fff',
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%'
  },
  thumbnail: {
    '& *': {
      pointerEvents: 'none',
      overflow: 'hidden !important'
    }
  }
})

const Slide = ({
  classes,
  children,
  className,
  accessibilityColor,
  containerClassName,
  style,
  onClick,
  slideProps = {}
}) => {
  const presentation = usePresentation()

  return (
    <div
      className={classNames(
        classes.container,
        slideProps.containerClassName,
        containerClassName,
        presentation.slideContainerClassName,
        { [classes.thumbnail]: presentation.thumbnail }
      )}>
      <div
        onClick={onClick}
        className={classNames(
          classes.holder,
          slideProps.className,
          className,
          presentation.slideHolderClassName
        )}
        style={{
          backgroundColor: accessibilityColors[accessibilityColor],
          fontFamily:
            presentation.fontType === 'cursive_a'
              ? '"XCCW Joined 4a"'
              : presentation.fontType === 'cursive_b'
              ? '"XCCW Joined 6a"'
              : 'inherit',
          ...style
        }}>
        {children}
      </div>
    </div>
  )
}

export default withPresentation(injectSheet(styles)(Slide))
